import axios from 'axios'

export async function logDocumentViewed(
  applicantId: number,
  documentId?: number,
  studentId?: number
) {
  return await axios.post('/log-document-view', {
    applicant_id: applicantId,
    image_id: documentId, // family_member_documents.id
    student_id: studentId,
  })
}
